import React from 'react';

import '@atlaskit/tokens/figma/atlassian-light.json';
import '@atlaskit/tokens/figma/atlassian-dark.json';

import { FastshiftPortalPageRouter } from './fastshift-portal-page-router';

export const FastshiftDashboardPageTemplate: React.FC = () => {
	return <FastshiftPortalPageRouter />;
};
